<template>
  <div class="sc-menu-element">
    <a class="sc-menu-item" :style="{color: colors.header.text}" role="button" @click.prevent="handleClick">
      {{item.title}}
      <span
      v-if="item.type == 'nested'"
      class="sc-menu-item-button"
      >&#8250;</span>
    </a>
  </div>
</template>
<script>
export default {
  name: 'MenuItem',
  inject: {
    colors: {
      type: Object
    }
  },
  props: {
    item: Object,
    parent: Object
  },
  methods: {
    handleClick() {
      switch (this.item.type) {
        case 'web_url':
          window.open(this.item.url, '_blank')
          break
        case 'nested':
          this.$emit('openSubItems', {
            ...this.item,
            _parent: this.parent,
          })
          break
        case 'postback':
          this.$emit('postback', {text: this.item.title, payload: this.item.payload})
          break
      }
    }
  }
}
</script>
<style scoped>
.sc-menu-element {
  border-top: 1px solid #b9b9b9;
  position: relative;
  font-size: 1rem;
  cursor: pointer;
}
.sc-menu-item {
  display: inline-block;
  padding: 1rem;
  text-decoration: none;
  width: 100%;
}
.sc-menu-item-button {
  display: inline-block;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.75rem;
  padding: 1rem;
}
</style>
